import axios from 'axios'
import qs from 'qs'
import store from '../store'
import router from '../router'
import {
    Message
} from 'element-ui';
// 创建 instance 请求对象
const instance = axios.create({
    baseURL: '', // 接口地址
    withCredentials: false, // 跨域请求时是否需要使用凭证
    timeout: 30000,
    validateStatus: function () {
        // 使用async-await，处理reject情况较为繁琐，所以全部返回resolve，在业务代码中处理异常
        return true
    }
})
axios.defaults.crossDomain = true
// 请求拦截器
instance.interceptors.request.use((config) => {
    if (store.state.authorization) { // 判断是否存在token，如果存在的话，则每个http header都加上token
        config.headers.authorization = store.state.authorization;
    }
    // 不包含支付接口
    if (!config.url.includes('/payment/') && !config.url.includes('/graphicalCms/invoice/add')&& !config.url.includes('/graphicalCms/invoice/detail')) {
        config.data = qs.stringify({
            ...config.data
        })
    }
    return config
}, (error) => {
    // 错误抛到业务代码
    error.data = {}
    error.data.msg = '服务器异常，请联系管理员！'
    return Promise.resolve(error)
})
// 响应拦截器
instance.interceptors.response.use((response) => {
    const status = response.status
    if (status < 200 || status >= 300) {
        // 错误信息提示
        Message.closeAll()
        // 登录过去跳转到登录
        if (status === 603 || status === 604 || status === 630) {
            Message({
                message: '登录过期',
                type: 'error'
            });
            store.state.authorization = ''
            router.push({
                path: '/login',
                query: router.history.current.fullPath
            })
        }
    }
    return response
}, (error) => {
    // 错误抛到业务代码
    error.data = {}
    error.data.msg = '请求超时或服务器异常，请检查网络或联系管理员！'
    return Promise.resolve(error)
})
export default instance